const TAG_SALE_STATUS = {
  VERIFIED: 'verified',
  UNVERIFIED: 'unverified'
};
export default {
  TAG_SALE_STATUS
};